import React from "react";

const AddressAutocomplete = ({ suggestions, onSelectAddress }) => {
  return (
    <div className="autocomplete-dropdown w-full bg-[white] px-4 pb-4 absolute z-50" >
      {suggestions?.map((address, index) => (
        <div
          key={index}
          className="autocomplete-item cursor-pointer"
          onClick={() => onSelectAddress(address)}
        >
          {address?.description}
        </div>
      ))}
    </div>
  );
};

export default AddressAutocomplete;
